import { injectable } from "inversify";
import { BASE_ELEMENT_IDS } from "../ui/BaseDOM";
import Regulation from "./Regulation";

@injectable()
export default class MtRegulation extends Regulation {
	init() {
		super.init();
		$("#" + BASE_ELEMENT_IDS.INFO_BOX_GAME_NAME).show();
	}
}
